<template>
  <section
    id="hero"
    @click="handleClick"
  >
    <v-img
      :src="require('@/assets/home-bg.jpg')"
      position="center center"
      contain
      class="white--text d-flex justify-center align-center"
    >
      <div class="slide-title">
        {{ $t('home.hero.title') }}
      </div>
      <div class="slide-subtitle">
        {{ $t('home.hero.subtitle') }}
      </div>
    </v-img>
  </section>
</template>

<script>
  import { mdiChevronRight } from '@mdi/js'
  export default {
    name: 'Hero',

    provide: {
      theme: { isDark: true },
    },
    data() {
      return {
        icon: {
          right: mdiChevronRight,
        },
      }
    },
    computed: {
      // mHeight() {
      //   const height = this.$vuetify.breakpoint.mdAndUp ? '60vh' : '56vh'
      //   return `calc(${height} - ${this.$vuetify.application.top}px)`
      // },
    },
    methods: {
      handleClick() {
        // 跳转到指定页面或执行其他操作
        // to: { name: 'ProductsItem', params: { itemId: 2 } },
        this.$router.push({ name: 'ProductsItem', params: { itemId: 2 } })
      },
    },
  }
</script>
<style lang="sass" scoped>
.noline
  text-decoration: none

// 确保背景图片填满容器，避免大屏幕留白
.v-img
  background-size: cover !important
  background-repeat: no-repeat !important
  background-position: center center !important
  position: relative

// Hero区域可点击样式
#hero
  cursor: pointer
  transition: opacity 0.3s ease

#hero:hover
  opacity: 0.9

// 标题样式
.slide-title
  text-align: left
  font-size: 5.3vw
  color: #333333
  font-weight: 500
  line-height: 120%
  position: absolute
  bottom: 34%
  left: 10vw

// 副标题样式
.slide-subtitle
  text-align: left
  font-size: 3.2vw
  color: #9f9f9f
  font-weight: 400
  text-transform: capitalize
  line-height: 1.2
  position: absolute
  bottom: 24%
  left: 10vw
</style>
